import ApplicationAdapter from './application';

export default class BillingTransferSetup extends ApplicationAdapter {
  fetch(params = {}) {
    let data = this.#channelParams(params);
    let options = Object.keys(data).length ? { data } : {};

    return this.ajax(this.#setupPath, 'GET', options);
  }

  submit({ consentAccepted, ...params } = {}) {
    return this.ajax(this.#setupPath, 'POST', {
      data: {
        consentAccepted: consentAccepted === true,
        ...this.#channelParams(params),
      },
    });
  }

  sync(params = {}) {
    return this.ajax(`${this.#setupPath}/sync`, 'POST', {
      data: this.#channelParams(params),
    });
  }

  handleResponse(...args) {
    let [status, , payload] = args;

    if (status >= 200 && status < 300) {
      return payload;
    }

    if (status === 422) {
      return { errors: this.#unprocessableErrors(status, payload) };
    }

    return super.handleResponse(...args);
  }

  get #setupPath() {
    return `${this.buildURL()}/billing_transfer_setup`;
  }

  #channelParams({ clientId, channelName } = {}) {
    return {
      ...(clientId ? { clientId } : {}),
      ...(channelName ? { channelName } : {}),
    };
  }

  #unprocessableErrors(status, payload) {
    let fieldErrors = Array.isArray(payload?.errors) ? payload.errors : [];
    let errors = [
      {
        status: `${status}`,
        title: payload?.error,
        detail: payload?.error,
        code: payload?.errorCode,
        meta: { fieldErrors },
      },
    ];

    fieldErrors.forEach(fieldError => {
      errors.push({
        status: `${status}`,
        title: fieldError.message,
        detail: fieldError.message,
        code: payload.errorCode,
        source: fieldError.field ? { pointer: fieldError.field } : undefined,
      });
    });

    return errors;
  }
}
